var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showMetamaskMessageBox
    ? _c("div", { staticClass: "message-box-bg flex-center" }, [
        _c("div", { staticClass: "message-box" }, [
          _c("div", { staticClass: "message-box-main" }, [
            _c("div", { staticClass: "message-box-top" }, [
              _c("h4", { staticClass: "flex-center" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("home.walletConnect.messageBox.title")) +
                    " "
                ),
              ]),
              _c("i", {
                staticClass: "icon icon-close",
                on: { click: _vm.onShowMessageBox },
              }),
            ]),
            _vm._m(0),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "box-but flex-center" }, [
      _c("i", { staticClass: "icon icon-metamask" }),
      _vm._v(" Connect MetaMask ... "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }